import { render, staticRenderFns } from "./QuestionViewAnswers.vue?vue&type=template&id=0cbca52e&scoped=true&lang=pug&"
import script from "./QuestionViewAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionViewAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbca52e",
  null
  
)

export default component.exports